// extracted by mini-css-extract-plugin
export default {"clickable":"b2j3Ty","clickable--round":"c2j3Ty"};